"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var PageAnalyticsController_1 = __importDefault(require("./PageAnalyticsController"));
var ProductSearchPageAnalyticsController = /** @class */ (function (_super) {
    __extends(ProductSearchPageAnalyticsController, _super);
    function ProductSearchPageAnalyticsController(datalayerManager) {
        return _super.call(this, 'ACS quick search', datalayerManager) || this;
    }
    ProductSearchPageAnalyticsController.prototype.track = function (trackingAction) {
        // Reset Selection Event
        if ('eventType' in trackingAction.data && trackingAction.data.eventType === 'resetSearchSelections') {
            PageAnalyticsController_1.default.sendEvent('ACS filter reset');
            return;
        }
        // show Search Results Event
        if ('eventType' in trackingAction.data && trackingAction.data.eventType === 'showSearchResults') {
            PageAnalyticsController_1.default.sendEvent('ACS show search results');
            return;
        }
        PageAnalyticsController_1.default.setSelectedFilters(trackingAction);
    };
    return ProductSearchPageAnalyticsController;
}(PageAnalyticsController_1.default));
exports.default = ProductSearchPageAnalyticsController;
